<template>
	<div class="c-s z-ant-input" v-if="isShow" style="position: fixed;top: 0;height: 100vh;z-index: 999;">
		<div :show="isShow" @click="_click(false) " style="position: initial;background-color: rgba(0, 0, 0, 0.7);height: 100%;width: var(--theme-max-width);" z-index="4" >
			 <div class="wrapper" >
				<div style="">
					<div class="ant-modal-content" @click.stop>
							<div class="ant-modal-header"><div id="rcDialogTitle1" class="ant-modal-title">Add Account</div></div>
							<div class="ant-modal-body">
								<div class="gD0G2pAAJZZTJ1n0KQXv" >
									<!-- margin-bottom: .5rem; -->
									<antInput  :clearable='false' @onInput="_onInput" :modelValue="forData.account_name" form-key='account_name'
										:placeholder="$t('components._Introduzaoseunomereal')">
										<div slot="left"
											style="color: var(--theme-text-color-darken);font-size:.18rem;display: flex;align-items: center;">
											<svg-icon className="prefix"
												icon-class="input_icon_zsxm--svgSprite:all" />
										</div>
									</antInput>
								</div>
								<div class="gD0G2pAAJZZTJ1n0KQXv">
									<antS @_click="chooseType" :dados="['BANK',]" :modelvalue="accountType">
										<div slot="left-icon"
										style="color: var(--theme-text-color-darken);font-size:.18rem;display: flex;align-items: center;"
										>
										<svg style="width: .36rem;height: .36rem;" fill="currentColor" viewBox="0 0 16 16">
											<path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z"/>
											<path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z"/>
										</svg>
										</div>
									</antS>
								</div>
								<div class="gD0G2pAAJZZTJ1n0KQXv" v-if="1">
									<antS @_click="chooseBank" :dados="bankList" :modelvalue="nowBank" fontSizeClass="spanfontsize18">
										<div slot="left-icon" style="color: var(--theme-text-color-darken);font-size:.18rem;display: flex;align-items: center;" >
										<svg-icon className="prefix" icon-class="input_icon_bank--svgSprite:all" />
										</div>
									</antS>
								</div>
								<div class="gD0G2pAAJZZTJ1n0KQXv">
									<antInput maxlength="50" :modelValue="forData.account_cpf" @onInput="_onInput" :clearable='false' form-key='account_cpf'
										placeholder="Enter your account No.">
										<div slot="left"
											style="color: var(--theme-text-color-darken);font-size:.18rem;display: flex;align-items: center;">
											<svg style="vertical-align: -0.15em;width: .36rem;height: .36rem;" fill="currentColor" viewBox="0 0 16 16">
												<path fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm9 1.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8Zm1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm-1 2c0 .17-.014.337-.04.5H2a1 1 0 0 1-.984-.819C1.2 10.398 2.914 9 5 9c2.21 0 4 1.567 4 3.5ZM7 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"/>
											</svg>
										</div>
									</antInput>
								</div>
								<div class="Kw58s_FCuipHRV_EW4tG">
									<span>{{ $t('withdraw._Verifique') }} </span>
								</div>
								<div class="Pt3rGlTmq0_WLpTGHsA_" @click="setBank">
									<van-button class="JHBAn8W0jkHI1OM_X2fy" type="primary">{{ $t('withdraw._Confirmar') }}</van-button>
								</div>
							</div>
					</div>
				</div>
				
			</div>
		</div>
		
	</div>
</template>

<script>
	import {
		setBank
	} from "@/apis/modules/login.js"
	import antInput from "./input.vue"
	import antInputPassword from "@/components/ant-input-password/index.vue"
	import antS from "./ant-s.vue"
	import { Toast } from 'vant';
	export default{
		components:{
			antInputPassword,
			antInput,
			antS
		},
		props:{
			isShow:{
				type:Boolean,
				default: false,
			},
			formDta:{
				type:[Object],
				default:()=>{return {}},
				
			}
			
		},
		data() {
			return{
				show:true,
				isShowNum:false,
				shuruKOangName:'',
				accountType:0,
				nowBank:0,
				forData:{
					account_name:'',
					account_pix:'',
					account_cpf:'',
					account_type:'BANK',
				},
				bankList : [
					'Please select a bank',
					'3LINE CARD MANAGEMENT LIMITED','9 PAYMENT SOLUTIONS BANK','AAA FINANCE AND INVESTMENT COMPANY LIMITED','AB MICROFINANCE BANK','ABBEY MORTGAGE BANK',
					'ABOVE ONLY MICROFINANCE BANK','ABU MICROFINANCE BANK','ABULESORO MICROFINANCE BANK','ACCELEREX NETWORK LIMITED','ACCESS BANK','ACCESS MONEY',
					'ACCESS YELLO','ACCESS(DIAMOND) BANK','ACCION MICROFINANCE BANK','ADDOSSER MICROFINANCE BANK','ADEYEMI COLLEGE STAFF MICROFINANCE BANK',
					'ADVANS LA FAYETTE MICROFINANCE BANK','AFEKHAFE MICROFINANCE BANK','AG MORTGAGE BANK','AGOSASA MICROFINANCE BANK','AKU MICROFINANCE BANK',
					'AKUCHUKWU MICROFINANCE BANK','AL-BARAKAH MICROFINANCE BANK','AL-HAYAT MICROFINANCE BANK','ALEKUN MICROFINANCE BANK','ALERT MICROFINANCE BANK',
					'ALLWORKERS MICROFINANCE BANK','ALPHA KAPITAL MICROFINANCE BANK','AMAC MICROFINANCE BANK','AMEGY MICROFINANCE BANK','AMJU UNIQUE MICROFINANCE BANK',
					'AMML MICROFINANCE BANK','AMPERSAND MICROFINANCE BANK','AMUCHA MICROFINANCE BANK','APPLE MICROFINANCE BANK','ARISE MICROFINANCE BANK','ASO SAVINGS',
					'ASPIRE MICROFINANCE BANK','ASSET MATRIX MICROFINANCE BANK','ASTRAPOLARIS MICROFINANCE BANK','AUCHI MICROFINANCE BANK','AWACASH MICROFINANCE BANK',
					'BABURA MICROFINANCE BANK','BAINES CREDIT MICROFINANCE BANK','BALERA MICROFINANCE BANK','BALOGUN GAMBARI MICROFINANCE BANK','BANC CORP MICROFINANCE BANK',
					'BAYERO UNIVERSITY MICROFINANCE BANK','BC KASH MICROFINANCE BANK','BERACHAH MICROFINANCE BANK','BESTSTAR MICROFINANCE BANK',
					'BOCTRUST MICROFINANCE BANK LIMITED','BORGU MICROFINANCE BANK','BOSAK MICROFINANCE BANK','BOWEN MICROFINANCE BANK','BRANCH INTERNATIONAL FINANCIAL SERVICES',
					'BRENT MORTGAGE BANK','BRETHREN MICROFINANCE BANK','BRIGHTWAY MICROFINANCE BANK','BROADVIEW MICROFINANCE BANK','CARBON','CASHBRIDGE MICROFINANCE BANK',
					'CASHCONNECT MICROFINANCE BANK','CATLAND MICROFINANCE BANK','CBN','CEDAR MICROFINANCE BANK','CELLULANT MOBILE MONEY','CEMCS MICROFINANCE BANK',
					'CHANELLE MICROFINANCE BANK','CHIKUM MICROFINANCE BANK','CIT MICROFINANCE BANK','CITI BANK','COASTLINE MICROFINANCE BANK','CONFIDENCE MICROFINANCE BANK',
					'CONSISTENT TRUST MICROFINANCE BANK','CONSUMER MICROFINANCE BANK','COOP MORTGAGE BANK','CORESTEP MICROFINANCE BANK','CORONATION MERCHANT BANK',
					'COUNTY FINANCE LIMITED','COVENANT MICROFINANCE BANK','CREDITVILLE MICROFINANCE BANK','CRESCENT MICROFINANCE BANK','CS ADVANCE FINANCE COMPANY LIMITED',
					'CYBERSPACE LIMITED','DAL MICROFINANCE BANK','DAVODANI MICROFINANCE BANK','DAYLIGHT MICROFINANCE BANK','DIGNITY FINANCE AND INVESTMENT LIMITED',
					'DIOBU MICROFINANCE BANK','DOT MICROFINANCE BANK','E-BARCS MICROFINANCE BANK','E-FINANCE','EAGLE FLIGHT MICROFINANCE BANK','EARTHOLEUM','ECOBANK',
					'ECOBANK XPRESS ACCOUNT','ECOMOBILE','EDFIN MICROFINANCE BANK','EK-RELIABLE MICROFINANCE BANK','EKONDO MICROFINANCE BANK','EMERALD MICROFINANCE BANK',
					'EMPIRE TRUST MICROFINANCE BANK','ENCO FINANCE COMPANY LTD','ENTERPRISE BANK','ESO-E MICROFINANCE BANK','ETRANZACT','EVANGEL MICROFINANCE BANK',
					'EVERGREEN MICROFINANCE BANK','EXCELLENT MICROFINANCE BANK','EYOWO','FAIRMONEY','FAST CREDIT LIMITED','FAST MICROFINANCE BANK','FBNQUEST MERCHANT BANK',
					'FCMB MOBILE','FEDERAL POLYTECHNIC NEKEDE MICROFINANCE BANK','FEDERAL UNIVERSITY DUTSE MICROFINANCE BANK','FEDETH MICROFINANCE BANK',
					'FEDPOLY NASARAWA MICROFINANCE BANK','FETS','FEWCHORE FINANCE COMPANY LIMITED','FFS MICROFINANCE BANK','FIDELITY BANK','FIDELITY MOBILE',
					'FIDFUND MICROFINANCE BANK','FINATRUST MICROFINANCE BANK','FINCA MICROFINANCE BANK','FIRMUS MICROFINANCE BANK','FIRST APPLE LIMITED',
					'FIRST BANK OF NIGERIA','FIRST CITY MONUMENT BANK','FIRST GENERATION MORTGAGE BANK','FIRST OPTION MICROFINANCE BANK','FIRST ROYAL MICROFINANCE BANK',
					'FIRST TRUST MORTGAGE BANK PLC','FIRSTMONIE WALLET','FLOURISH MICROFINANCE BANK','FLUTTERWAVE TECHNOLOGY SOLUTIONS LIMITED','FORESIGHT MICROFINANCE BANK',
					'FORTIS MICROFINANCE BANK','FORTIS MOBILE','FSDH','FULLRANGE MICROFINANCE BANK','FUTO MICROFINANCE BANK','GABASAWA MICROFINANCE BANK',
					'GABSYN MICROFINANCE BANK','GASHUA MICROFINANCE BANK','GATEWAY MORTGAGE BANK','GIDAUNIYAR ALHERI MICROFINANCE BANK','GIREI MICROFINANACE BANK',
					'GLOBAL INITIATIVE MICROFINANCE BANK','GLOBUS BANK','GLORY MICROFINANCE BANK','GMB MICROFINANCE BANK','GOODNEWS MICROFINANCE BANK','GOWANS MICROFINANCE BANK',
					'GREEN ENERGY MICROFINANCE BANK','GREENBANK MICROFINANCE BANK','GREENVILLE MICROFINANCE BANK','GREENWICH MERCHANT BANK','GROOMING MICROFINANCE BANK',
					'GT MOBILE','GTI MICROFINANCE BANK','GUARANTEE TRUST BANK','HAGGAI MORTGAGE BANK LIMITED','HALALCREDIT MICROFINANCE BANK','HASAL MICROFINANCE BANK',
					'HEADWAY MICROFINANCE BANK','HEDONMARK','HERITAGE BANK','HOMEBASE MORTGAGE BANK','HOPEPSB','IBILE MICROFINANCE BANK','IBOLO MICROFINANCE BANK',
					'IBOM FADAMA MICROFINANCE BANK','IC GLOBAL MICROFINANCE BANK','IJEBU-IFE MICROFINANCE BANK','IKENNE MICROFINANCE BANK','IKIRE MICROFINANCE BANK',
					'ILARO POLY MICROFINANCE BANK','ILISAN MICROFINANCE BANK','IMO STATE MICROFINANCE BANK','IMPERIAL HOMES MORTGAGE BANK','INFINITY MICROFINANCE BANK',
					'INFINITY TRUST MORTGAGE BANK','INNOVECTIVES KESH','INTELLIFIN','INTERLAND MICROFINANCE BANK','INTERSWITCH LIMITED','IRL MICROFINANCE BANK',
					'ISALEOYO MICROFINANCE BANK','ISLAND MICROFINANCE BANK','IYE OKIN MICROFINANCE BANK LTD','IYIN EKITI MICROFINANCE BANK','JAIZ BANK','JUBILEE LIFE',
					'KADPOLY MICROFINANCE BANK','KAYVEE MICROFINANCE BANK','KC MICROFINANCE BANK','KCMB MICROFINANCE BANK','KEGOW(CHAMSMOBILE)','KEYSTONE BANK',
					'KKU MICROFINANCE BANK','KONGAPAY','KONTAGORA MICROFINANCE BANK','KOPO KOPE MICROFINANCE BANK','KREDI MONEY MICROFINANCE BANK','KUDA MICROFINANCE BANK',
					'LAGOS BUILDING AND INVESTMENT COMPANY','LAPO MICROFINANCE BANK','LAVENDER MICROFINANCE BANK','LEADREMIT LIMITED','LEGEND MICROFINANCE BANK',
					'LETSHEGO MICROFI','LIFEGATE MICROFINANCE BANK','LINKS MICROFINANCE BANK','LIVINGTRUST MORTGAGE BANK PLC','LOTUS BANK','LOVONUS MICROFINANCE BANK',
					'LUKEFIELD FINANCE COMPANY LIMITED','M36','MAB ALLIANZ MICROFINANCE BANK','MABINAS MICROFINANCE BANK','MACROD MICROFINANCE BANK LIMITED',
					'MADOBI MICROFINANCE BANK','MAINLAND MICROFINANCE BANK','MAINSTREET MICROFINANCE BANK','MALACHY MICROFINANCE BANK','MARITIME MICROFINANCE BANK',
					'MAYFRESH MORTGAGE BANK','MEDEF MICROFINANCE BANK','MEGAPRAISE MICROFINANCE BANK','MERIDAN MFB','MICROCRED MICROFINANCE BANK','MICROVIS MICROFINANCE BANK',
					'MIDLAND MICROFINANCE BANK','MINJIBIR MICROFINANCE BANK','MINT-FINEX MFB','MKOBO MICROFINANCE BANK','MKUDI','MOLUSI MICROFINANCE BANK',
					'MOMO PAYMENT SERVICE BANK','MONEY BOX','MONEY TRUST MICROFINANCE BANK','MONEYMASTER PSB','MONIEPOINT MICROFINANCE BANK','MOZFIN MICROFINANCE BANK',
					'MUTUAL BENEFITS MICROFINANCE BANK','MUTUAL TRUST MICROFINANCE BANK','NAGARTA MICROFINANCE BANK','NDIORAH MICROFINANCE BANK','NEPTUNE MICROFINANCE BANK',
					'NEW DAWN MICROFINANCE BANK','NEW GOLDEN PASTURES MICROFINANCE BANK','NEW PRUDENTIAL BANK','NIGERIA PRISONS MICROFINANCE BANK',
					'NIGERIAN NAVY MICROFINANCE BANK','NIP VIRTUAL BANK','NIRSAL NATIONAL MICROFINANCE BANK','NNEW WOMEN MICROFINANCE BANK','NOVA MERCHANT BANK',
					'NOWNOW DIGITAL SYSTEMS LIMITED','NPF MICROFINANCE BANK','NSEHE MICROFINANCE BANK','NWANNEGADI MICROFINANCE BANK','OCHE MICROFINANCE BANK',
					'OHAFIA MICROFINANCE BANK','OHHA MICROFINANCE BANK','OKE-ARO OREDEGBE MFB','OKPOGA MICROFINANCE BANK','OKUKU MICROFINANCE BANK',
					'OLABISI ONABANJO UNIVERSITY MICROFINANCE','OLOWOLAGBA MICROFINANCE BANK','OMIYE MICROFINANCE BANK','OPAY','OPTIMUS BANK','OROKAM MICROFINANCE BANK',
					'OSCOTECH MICROFINANCE BANK','OTECH MICROFINANCE BANK','OTUO MICROFINANCE BANK','OYAN MICROFINANCE BANK','PAGA','PAGE MFBANK','PALMPAY','PARALLEX BANK',
					'PARKWAY-READYCASH','PATRICKGOLD MICROFINANCE BANK','PAYATTITUDE ONLINE','PAYSTACK PAYMENT LIMITED','PEACE MICROFINANCE BANK','PECANTRUST MICROFINANCE BANK',
					'PENNYWISE MICROFINANCE BANK','PERSONAL TRUST MICROFINANCE BANK','PETRA MICROFINANCE BANK','PILLAR MICROFINANCE BANK','PLATINUM MORTGAGE BANK','POLARIS BANK',
					'POLYUNWANA MICROFINANCE BANK','PREMIUM TRUST BANK','PRESTIGE MICROFINANCE BANK','PROVIDUS BANK','QUICKFUND MICROFINANCE BANK','RAND MERCHANT BANK',
					'RAYYAN MICROFINANCE BANK','REFUGE MORTGAGE BANK','REGENT MICROFINANCE BANK','REHOBOTH MICROFINANCE BANK','RELIANCE MICROFINANCE BANK',
					'RENMONEY MICROFINANCE BANK','REPHIDIM MICROFINANCE BANK','RICHWAY MICROFINANCE BANK','RIGO MICROFINANCE BANK','RIMA GROWTH PATHWAY MICROFINANCE BANK',
					'ROCKSHIELD MICROFINANCE BANK','ROYAL EXCHANGE MICROFINANCE BANK','RUBIES MICROFINANCE BANK','SAFE HAVEN MICROFINANCE BANK','SAFEGATE MICROFINANCE BANK',
					'SAFETRUST','SAGAMU MICROFINANCE BANK','SAGE GREY FINANCE LIMITED','SEAP MICROFINANCE BANK','SEEDVEST MICROFINANCE BANK','SHALOM MICROFINANCE BANK',
					'SHERPERD TRUST MICROFINANCE BANK','SHIELD MICROFINANCE BANK','SHONGOM MICROFINANCE BANK','SIGNATURE BANK','SIMPLE FINANCE LIMITED','SLS MICROFINANCE BANK',
					'SMARTCASH PAYMENT SERVICE BANK','SOLID ALLIANZE MICROFINANCE BANK','SOLIDROCK MICROFINANCE BANK','SOURCE MICROFINANCE BANK','SPARKLE',
					'SPECTRUM MICROFINANCE BANK','STANBIC IBTC @EASE WALLET','STANBIC IBTC BANK','STANDARD CHARTERED BANK','STANFORD MICROFINANCE BANK','STATESIDE MFB',
					'STELLAS MICROFINANCE BANK','STERLING BANK','STERLING MOBILE','SULSPAP MICROFINANCE BANK','SUNTRUST BANK','SUPPORT MICROFINANCE BANK',
					'SUPREME MICROFINANCE BANK','TAGPAY','TAJ BANK','TANADI MFB (CRUST)','TANGALE MICROFINANCE BANK','TANGERINE MONEY','TCF MICROFINANCE BANK',
					'TEAMAPT LIMITED','TEASY MOBILE','TEKLA FACTORING AND FINANCE LIMITED','THINK FINANCE MICROFINANCE BANK','TITAN TRUST BANK','TITAN-PAYSTACK',
					'TOTAL TRUST MICROFINANCE BANK','TRIDENT MICROFINANCE BANK','TRINITY FINANCE','TRIPLEA MICROFINANCE BANK','TRUST MICROFINANCE BANK',
					'TRUSTBANC J6 MICROFINANCE BANK LIMITED','TRUSTBOND MORTGAGE BANK','TRUSTFUND MICROFINANCE BANK','U & C MICROFINANCE BANK','UDA MICROFINANCE BANK',
					'UHURU MICROFINANCE BANK','UMMAH MICROFINANCE BANK','UNAAB MICROFINANCE BANK','UNIBEN MICROFINANCE BANK','UNICAL MICROFINANCE BANK',
					'UNIFUND MICROFINANCE BANK LIMITED','UNILORIN MFB','UNION BANK NIGERIA','UNITED BANK FOR AFRICA','UNITY BANK','UNIVERSITY OF NIGERIA, NSUKKA MICROFINANCE BANK',
					'UZONDU MICROFINANCE BANK','VENTURE GARDEN NIGERIA LIMITED','VFD MFB','VISA MICROFINANCE BANK','VT NETWORKS','WEMA BANK','WETLAND MICROFINANCE BANK',
					'XSLNCE MICROFINANCE BANK','YCT MICROFINANCE BANK','YES MICROFINANCE BANK','YOBE MICROFINANCE BANK','ZENITH BANK','ZENITH EAZY WALLET','ZENITH MOBILE',
					'ZIKORA MICROFINANCE BANK',
				],
			}
		},
		watch: {
		    // 当message变化时，这个函数就会被调用
		    isShow(newValue, oldValue) {
				this.forData = this.formDta.account_type ? {...this.formDta} : {account_name:'',account_pix:'',account_cpf:'',account_type:'BANK',};
				if(this.forData.account_type){
					this.accountType=0;
				}
				this.nowBank = this.forData.account_pix || 0;
				
		  //     console.log(this.forData,newValue);
		      // 这里可以添加更多响应数据变化的逻辑
		    }
		  },
		methods:{
			_click(){
				this.$emit('_click',false)
			},
			chooseType(item,index){
				this.accountType=index;
				this.forData.account_type=item;
			},
			chooseBank(item,index){
				this.nowBank=index;
				this.forData.account_pix=index;
			},
			_onInput(v,k){
				this.forData[k]=v;
			},
			setBank(){
				let msg = '';
				if(!this.forData.account_name)msg = this.$t('_homeTile_tab._campodeNomereal');
				if(!msg && this.forData.account_pix < 1){msg = 'Please select a bank'}
				if(!msg && (!this.forData.account_cpf || this.forData.account_cpf.length < 7 || this.forData.account_cpf.length > 20)){msg = 'Enter the correct account No.'}
				if(msg){
					Toast.fail({
						message:this.myLineBreaks(msg),
						duration:0
					});
					setTimeout(()=>{
						Toast.clear()
					},1000)
					return false;
				}

				setBank({...this.forData}).then(({code,msg,data})=>{
					if(code==0){
						Toast.success({
							message:this.myLineBreaks(msg),
							duration:1000
						});
						setTimeout(()=>{
							location.reload();
							this.$attrs.getBank();
							this.$emit('onIsShow',false)
						},1500)
						return false;
					}
					Toast.loading({
						message:this.myLineBreaks(msg),
						duration:1000
					});
				})
			}
		}
	}
</script>
<style>
/* 	.c-s{
		width: 100%;
		height: 100vh;
	} */
	.c-s{
		width: 100vw;
	}
	.c-s .van-overlay{
		width: 100vw;
		/* position: absolute;
		    background-color: rgba(0, 0, 0, .45); */
	}
	.van-field__body input{
		font-size: 0.27rem;
	}
</style>
<style scoped>
	
	.wrapper{
		 display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		width: 100%;
	}
	 .ant-modal-content {
	    background-color: var(--theme-main-bg-color);
	    border-width: thin;
	    border-style: solid;
	    border-image: initial;
		box-sizing: border-box;
		width: 6.9rem;
	    border-color: var(--theme-color-line);
	    border-radius: 0.2rem;
	    max-height: calc(var(--vh, 1vh)*100 - .1rem);
	    overflow: auto;
	    position: static;
		margin: 0 auto;
	}
	.gD0G2pAAJZZTJ1n0KQXv{
		margin-bottom: .5rem;
	}
	.ant-modal-header{
		 background-color: var(--theme-main-bg-color);
		    border-bottom: none;
		    border-radius: .2rem .2rem 0 0;
		    padding: .2rem .3rem
	}
	.ant-modal-title{
			color: var(--theme-text-color-darken);
		    font-size: .24rem;
		    font-weight: revert;
		    line-height: .34rem;
		    text-align: center;
	}
	.Ou1aviPriFX421w97dGA{
		display: flex;
		align-items: center;
		justify-content: space-between;
		    margin-bottom: .15rem;
		    font-size: .22rem;
			    color: var(--theme-text-color-darken);
	}
	.Ou1aviPriFX421w97dGA .ZaAWGnvFuhPwlBk40od_{
		font-size: .36rem;
		width: .36rem;
		height: .36rem;
		    color: var(--theme-text-color-lighten);
	}
	.Ou1aviPriFX421w97dGA .isShowNum .ZaAWGnvFuhPwlBk40od_{
		color: var(--theme-primary-color);
	}
	.ant-modal-body{
		    padding-top: .2rem !important;
		    padding: .3rem;
	}
	.Kw58s_FCuipHRV_EW4tG{
		    color: var(--theme-text-color-darken);
		    font-size: .22rem;
			display: flex;
	}
	._7B8oTwzAn2VmdNYw3F0z {
	    color: var(--theme-primary-color);
	    cursor: pointer;
	    text-align: right;
	}
	.closeIcon{
		
	}
	.QzRd3YqTnYxG8Latq8fW {
	    background: none;
	    height: .64rem;
	    width: .64rem;
		margin: 0 auto;
	}
	.QzRd3YqTnYxG8Latq8fW img{
		width: 100%;
		height: 100%;
	}
	.JHBAn8W0jkHI1OM_X2fy {
	    border-radius: .14rem;
	    font-size: .24rem;
		width: 100%;
	    height: .7rem;
		 background-color: var(--theme-primary-color);
		border-color: var(--theme-primary-color);
	    line-height: .7rem;
	}
</style>